import React, { Component } from 'react';
import { withRouter } from 'react-router';

import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { DataHubPlayerService } from 'modules/app/services/datahub/player';
import { FileService } from 'modules/file';
import PropTypes from 'prop-types';

import FilePlayerSection from './FilePlayerSection';
import FileVideoUpload from './FileVideoUpload';
import NewMediaButton from './newMediaButton';

import { ENTITY_TYPE } from '../../constants';

import { UploadManager } from '@hotmart/club-files-ui';

@inject((stores) => ({
  isStreamingEnabled: stores.MembershipStore.isStreamingEnabled,
  isStreamingFreeContentEnabled:
    stores.MembershipStore.isStreamingFreeContentEnabled,
  marketplaceId: stores.UserStore.marketplaceId
}))
@observer
class FilePlayerGroup extends Component {
  static propTypes = {
    isPageFreeContent: PropTypes.bool,
    entity: PropTypes.string,
    setMediaUrl: PropTypes.func,
    isStreamingFreeContentEnabled: PropTypes.bool,
    isStreamingEnabled: PropTypes.bool,
    marketplaceId: PropTypes.number,
    onSetThumbnail: PropTypes.func,
    sortedMedias: PropTypes.oneOfType([
      MobxPropTypes.observableArray,
      PropTypes.arrayOf(PropTypes.object)
    ])
  };

  get isEmpty() {
    return this.props.sortedMedias.length === 0;
  }

  trackingEvents() {
    if (!this.isUploadStreamingEnabled) {
      DataHubPlayerService.showPlayerActivateBannerEvent();
    } else {
      DataHubPlayerService.showPlayerAlreadyActivatedEvent();
    }
  }

  componentDidMount() {
    this.trackingEvents();
  }

  get isUploadStreamingEnabled() {
    const {
      isPageFreeContent,
      isStreamingFreeContentEnabled,
      isStreamingEnabled
    } = this.props;

    if (isPageFreeContent) {
      return isStreamingFreeContentEnabled;
    } else {
      return isStreamingEnabled;
    }
  }

  hasVideoUpload = () => {
    const shouldAppearActive = true;
    return this.isUploadStreamingEnabled || shouldAppearActive;
  };

  render() {
    const { entity, fileLibraryProvider, sortedMedias, onSetThumbnail } =
      this.props;
    const showVideoUpload = this.isEmpty && this.hasVideoUpload();
    const showPlayerSection = !this.isEmpty && this.isUploadStreamingEnabled;
    const hasStreamingActivationModal = !this.isUploadStreamingEnabled;

    return (
      <div className="file__player__group">
        {showVideoUpload && (
          <FileVideoUpload
            reusable
            entityType={entity}
            hasStreamingActivationModal={hasStreamingActivationModal}
            fileLibraryProvider={fileLibraryProvider}
          />
        )}

        {showPlayerSection && (
          <div className="file__media__list">
            {sortedMedias.map((media, index) => (
              <FilePlayerSection
                {...media}
                reusable
                key={media.id}
                entityType={entity}
                {...(index === 0 && { onSetThumbnail })}
                fileLibraryProvider={fileLibraryProvider}
              />
            ))}

            <NewMediaButton
              reusable
              countEntity={sortedMedias.length}
              entityType={entity}
              fileLibraryProvider={fileLibraryProvider}
            />
          </div>
        )}
      </div>
    );
  }

  setMediaUrl = (...props) => {
    const { setMediaUrl } = this.props;

    setMediaUrl && setMediaUrl(...props);
  };
}

/** @type import('react').ComponentType<any> */
const hocUploadManager = withRouter(({ match, entityId, ...props }) => (
  <UploadManager
    {...props}
    entity={ENTITY_TYPE.PAGE_MEDIA}
    entityId={entityId || match.params.id}
    itemsProp="medias"
    onError={FileService.handleFileException}
  >
    <FilePlayerGroup sortedMedias={props.sortedMedias} />
  </UploadManager>
));

export default hocUploadManager;
